export default __webpack_public_path__ + "static/media/21.d04aeb3e.png";